module.exports = __webpack_public_path__ + "static/media/icon_simpleCheck.b1d048af.svg";